import axios from 'axios'
import { url } from './global'

/**
 * Lista paginada de tenants (mismo patrón que marcas/sucursales: page, size, nombre, activo).
 */
export const getAllTenants = async (
    activo,
    page,
    nombre = '',
    size = 50
) => {
    const token = sessionStorage.getItem('token')
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const q = nombre ? `nombre=${encodeURIComponent(nombre)}&` : ''
    const res = await axios.get(
        `${url}/tenants?${q}activo=${activo}&page=${page}&size=${size}`,
        { headers }
    )
    return res
}

export const registerTenant = async (payload) => {
    const token = sessionStorage.getItem('token')
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.post(`${url}/tenant/registrar`, payload, {
        headers,
    })
    return res
}
